import Cookies from 'js-cookie'

export default () => {
  const close = document.querySelector('.js-close-notice')
  if (!close) return

  close.addEventListener('click', function() {
    Cookies.set('notice', this.dataset.hash)
    this.parentNode.classList.add('c-sticky-notice--is-hidden')
  })
}



// WEBPACK FOOTER //
// ./src/js/modules/StickyNotice.js